import { useState } from "react";
import { Pod, PodAddProviderRequest } from "../../../api/pods.types";
import AddProviderDialog from "../dialogs/AddProviderDialog";

const useAddProviderDialog = (pod: Pod | undefined, handleSubmit: (data: PodAddProviderRequest, skipAssignmentCheck?: boolean) => void): [JSX.Element, Function, Function, Function, Function] => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorText, setErrorText] = useState('');

  const showDialog = () => {
    setLoading(false);
    setErrorText('');
    setVisible(true);
  };

  const hideDialog = () => setVisible(false);

  const setIsLoading = (loading: boolean) => {
    setLoading(loading);
    setErrorText('');
  };

  const setError = (error: string) => {
    setLoading(false);
    setErrorText(error);
  };

  const dialogComponent = (
    <AddProviderDialog
      show={visible}
      loading={loading}
      error={errorText}
      pod={pod} // See comment below.
      onSubmit={handleSubmit}
      onDismiss={hideDialog}
    />
  );

  /**
   * We pass in the pod in order to catch some early errors before hitting the API.
   * In particular, we're comparing the state of the pod with the provider type the
   * user selects and proactively disabling submission if the pod doesn't have any
   * slots left for that provider type. This is easy to check and saves the server
   * some compute (since it has to hit backenddb to infer the provider's type), but
   * the logic is mirrored on the server to ensure that requests that aren't obviously
   * invalid are still rebuffed (e.g., in the case of multiple users adding a provider
   * to different pods simultaneously, in which case our client-side validation could
   * be out-of-date and incorrectly allow the requests through).
   */

  return [
    dialogComponent,
    showDialog,
    hideDialog,
    setIsLoading,
    setError,
  ];
};

export default useAddProviderDialog;